module.exports = __webpack_public_path__ + "img/SaveToLabBook-24px.3c09b05d.svg";